import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { FlowRunAction } from "../obj/FlowRunAction";
import { ApplicationInsightsService } from '../services/application-insights.service';
//import { AnalyticsService } from '../services/analytics.service';

@Component({
    selector: 'app-flow-actions',
    templateUrl: './flow-actions.component.html',
    styleUrls: ['./flow-actions.component.css'],
    standalone: false
})
export class FlowActionsComponent implements OnInit {

  constructor(
    //private analytics: AnalyticsService
    private appInsights: ApplicationInsightsService
  ) { }

  state: State = {
    skip: 0,
    take: null,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  view: GridDataResult;

  @Input()
  public actions: FlowRunAction[];

  @ViewChild('actionsgrid', {static: true}) actionsgrid;

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.view = process(this.actions, this.state);
  }

  ngOnInit() {
    this.refreshRunGrid();
  }

  refreshRunGrid() {
    this.state.take = this.actions.length;
    this.view = process(this.actions, this.state);
  }

  public onSelect({ dataItem, item }): void {

    //this.analytics.send("actions", item);
    //this.appInsights.logPageView(`actions: ${item}`);
    this.appInsights.trackEvent(`actions`, { "select": item });

    switch (item) {
        case "Export Excel": {
            this.actionsgrid.saveAsExcel();
            break;
          }
        default:
            break;
    }

}

}
